import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-common-dropdown-search',
  templateUrl: './common-dropdown-search.component.html',
  styleUrls: ['./common-dropdown-search.component.css']
})
export class CommonDropdownSearchComponent implements OnInit {
  @Input() data;
  @Input() addFieldSetting;
  @Input() width;
  @Output() callEvent = new EventEmitter<any>();

  fieldSetting = {
    singleSelection: true,
    itemsShowLimit: 2,
    closeDropDownOnSelection: true,
    allowSearchFilter: true
  };
  activeUserList = [];
  userList = [];
  title:String = '';

  constructor() {

  }

  ngOnInit(): void {
    this.fieldSetting = { ...this.fieldSetting, ...this.addFieldSetting };
      const idField = this.addFieldSetting.idField
      const textField = this.addFieldSetting.textField
    if(this.width){
      const dropdownPanel = document.querySelector('.multiselect-dropdown');
      // Add styles using the style property
      dropdownPanel['classList'].add('width');
    }


    // Check if there's only one item in the data
    if (this.data.length === 1) {
      // Set the selected item(s) to the first item in the data
      this.activeUserList = [this.data[0]];
      this.setEvent(this.activeUserList[0])
    }

    this.addFieldSetting[idField] = ""
    this.addFieldSetting[textField] = "--Select--"
    this.data.unshift(this.addFieldSetting);
  }

  setEvent(event){
    this.title = event.Client_Name;
    this.callEvent.emit(event);
  }

  removeEvent(event){
    this.title = '';
    this.callEvent.emit();
  }

}
